export var CertificationInclude = {
    logo: true,
};
//# sourceMappingURL=Certification.js.map